
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rivenditori",
      function () {
        return require("private-next-pages/rivenditori/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rivenditori"])
      });
    }
  